import React, { useState } from 'react';
// import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
import { dedupedRequest } from '../utils/axios';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const PasswordChange = () => {
  const navigate = useNavigate();
  // const { login } = useAuth();
  // const { login, isAuthenticated, user, token } = useAuth();
  const { isAuthenticated, user } = useAuth();

  const [old_password, setOldPassword] = useState('');
  const [new_password, setNewPassword] = useState('');
  const [new_password_repeat, setNewPasswordRepeat] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    setLoading(true);
    setError('');
    if (new_password !== new_password_repeat) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      setLoading(false);
      return;
    }
    try {
      const res = await dedupedRequest<{ access_token: string }>(
        {
          method: 'POST',
          url: '/password/change',           // baseURL '/api' is applied in axios.ts
          data: { old_password, new_password },
          withCredentials: true,   // ensure refresh cookie is set on successful login
          headers: { 'Content-Type': 'application/json' },
        },
        { useCache: false, maxRetries: 0 } // no caching; avoid retries on bad creds
      );
      const status = res.status;
      if (status !== 204) {
        throw new Error('Passwortänderung fehlgeschlagen.');
      } else {
        if (isAuthenticated && user) {
          // Only redirect after auth context has updated!
          if (user.role === 'admin') navigate('/dashboard');
          else if (user.role === 'superadmin') navigate('/admin/laws');
          else if (user.role === 'client') navigate('/dashboard');
          else if (user.role === 'justiz') navigate('/medizinprodukteregister');
        }
      }
    } catch (err: any) {
      // Axios errors often have response.data with details
      let msg = 'Passwortänderung fehlgeschlagen';
      
      // Check for 401 Unauthorized - show user-friendly message
      if (err?.response?.status === 401) {
        msg = 'Falsches altes Passwort. Bitte überprüfen Sie Ihre Eingabe.';
      } else {
        msg =
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          err?.message ||
          msg;
      }
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto">

      <form onSubmit={handleSubmit}>
        <Card style={{ width: '24rem' }}>
          <Card.Body>
            <Card.Title><h2>Passwort ändern</h2></Card.Title>
              <div data-mdb-input-init className="form-outline mb-2">
                <input
                  className='form-control'
                  id="OldPasswordInput"
                  type="password"
                  value={old_password}
                  onChange={(e) => setOldPassword(e.target.value)}
                  placeholder="Altes Passwort"
                  required
                />
              </div>
              <div data-mdb-input-init className="form-outline mb-2">
                <input
                  className='form-control'
                  id="NewPasswordInput1"
                  type="password"
                  value={new_password}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Neues Passwort"
                  required
                />
              </div>
              <div data-mdb-input-init className="form-outline mb-2">
                <input
                  className='form-control'
                  id="NewPasswordInput2"
                  type="password"
                  value={new_password_repeat}
                  onChange={(e) => setNewPasswordRepeat(e.target.value)}
                  placeholder="Neues Passwort wiederholen"
                  required
                />
              </div>
              <button type="submit" data-mdb-button-init data-mdb-ripple-init className="btn btn-primary btn-block mb-4">Abschicken</button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </Card.Body>
        </Card>

      </form>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordChange;
